import { Address } from '../user';

export class AddressData {
    address: Address;
}
